import EditUser from './EditUser';

export default EditUser;



// WEBPACK FOOTER //
// ./src/components/Modals/EditUser/index.jsx